/**
 * 已完成页面：与设计测试并列，用于全屏展示 MCP/人工落盘的主页面。
 * 每新增一页：在数组末尾追加一项（展示时按倒序，最新在前）。
 *
 * 约定（与 .cursor 规则一致）：
 * - 可提交仓库的页面：放在 `preview/src/completed-page-views/`
 * - 仅本地的 MCP 批量产出：可放在仓库根 `PMSmart/generated-pages/`（常被 .gitignore），
 *   需在本地把路由指到对应文件，或复制到 `completed-page-views/` 后再注册，以免 CI 缺文件报错。
 */

export const COMPLETED_PAGES = [
  {
    id: 'design-test-rebar-1',
    title: '钢筋模板 · 工作台',
    component: () => import('../design-test-views/DesignTestRebar1View.vue'),
  },
  {
    id: 'rebar-budget-pane-topbar',
    title: '钢筋预算 · 顶栏操作',
    component: () => import('../design-test-views/DesignTest32RebarBudgetMultiPanelView.vue'),
  },
  {
    id: 'rebar-budget-pane-focus',
    title: '钢筋预算 · 随焦操作',
    component: () => import('../design-test-views/DesignTest321RebarBudgetMultiPanelView.vue'),
  },
  {
    id: 'design-test-concrete-1',
    title: '混凝土模板 · 工作台',
    component: () => import('../design-test-views/DesignTestConcrete1View.vue'),
  },
  {
    id: 'dt29-concrete-pour-order',
    title: '基建浇筑令',
    component: () => import('../design-test-views/DesignTest29ConcretePourOrderView.vue'),
  },
  {
    id: 'dt30-construction-log',
    title: '进度管理日志',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogListView.vue'),
  },
  {
    id: 'infra-home-1',
    title: '基建首页1',
    component: () => import('../design-test-views/DesignTest33MixAppOverviewView.vue'),
  },
  {
    id: 'infra-home-2',
    title: '基建首页2',
    component: () => import('../design-test-views/DesignTest34MixAppOverviewView.vue'),
  },
  {
    id: 'dt20-app-mini-functions',
    title: '机电管理 · App v1',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestAppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    id: 'dt21-mep-cable-inbound',
    title: '机电电缆单据',
    component: () => import('../design-test-views/DesignTest21MepCableInboundListView.vue'),
  },
  {
    id: 'dt35-mep-loss-management',
    title: '机电损耗管理',
    component: () => import('../design-test-views/DesignTest35MepCableLossDashboardView.vue'),
  },
  {
    id: 'dt37-new-mep-management',
    title: '机电管理 · Web v2',
    component: () =>
      import('../completed-page-views/dt37-new-mep-management/DesignTest37MepCableQuotaHubTertiaryView.vue'),
  },
  {
    id: 'dt31-mep-cable-reel-review',
    title: '机电电缆盘复核',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest31AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    id: 'dt28-rebar-opt-report-sidebar',
    title: '钢筋优化管理 · 智能分析报告（侧轨）',
    component: () =>
      import('../completed-page-views/dt28-rebar-opt-report-sidebar/DesignTest28RebarOptReportSidebarView.vue'),
  },
  {
    id: 'dt38-app-mini-functions-v2',
    title: '机电管理 · App v2',
    component: () =>
      import('../completed-page-views/dt38-app-mini-functions-v2/DesignTest38AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    id: 'dt39-formwork-plan',
    title: '模架策划',
    component: () =>
      import('../completed-page-views/dt39-formwork-plan/DesignTest39FormworkPlanCalcView.vue'),
  },
  {
    id: 'dt40-issue-ledger',
    title: '问题台账（钢筋量差）',
    component: () => import('../design-test-views/DesignTest40IssueLedgerView.vue'),
  },
  {
    id: 'dt41-app-mini-functions-v3',
    title: '机电管理 · App v3',
    component: () =>
      import('../completed-page-views/dt41-app-mini-functions-v3/DesignTest41AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    id: 'dt42-ai-rebar-sample',
    title: 'AI单据录入 · 钢筋翻样单 v1',
    component: () =>
      import('../completed-page-views/dt42-ai-rebar-sample/DesignTest42AiRebarSampleUploadView.vue'),
  },
  {
    id: 'dt43-rebar-opt-ai-sidebar',
    title: '钢筋优化管理 · 智能分析报告（AI侧边栏）',
    component: () =>
      import('../completed-page-views/dt43-rebar-opt-ai-sidebar/DesignTest43RebarOptAiSidebarView.vue'),
  },
  {
    id: 'dt44-infra-pour-order-app',
    title: '基建浇筑令 · App',
    component: () =>
      import('../design-test-views/DesignTest44InfraPourOrderAppView.vue'),
  },
  {
    id: 'dt45-infra-pour-order-app',
    title: '基建浇筑令 · App v2',
    component: () =>
      import('../design-test-views/DesignTest45InfraPourOrderAppView.vue'),
  },
  {
    id: 'dt46-rebar-plan-efficiency',
    title: '钢筋策划创效 · 导航壳',
    component: () =>
      import('../design-test-views/DesignTest46RebarPlanEfficiencyNavView.vue'),
  },
  {
    id: 'dt47-system-screenshot-cell',
    title: '问题台账 · 系统截图加载',
    component: () =>
      import('../design-test-views/DesignTest47SystemScreenshotCellView.vue'),
  },
  {
    id: 'dt48-drawing-list-ai-parse',
    title: '图纸列表 · AI解析条',
    component: () =>
      import('../design-test-views/DesignTest48DrawingListAiParseView.vue'),
  },
  {
    id: 'dt49-rebar-combo-calc',
    title: '钢筋组合下料 · 计算中浮层',
    component: () =>
      import('../design-test-views/DesignTest49RebarComboCalcDialogView.vue'),
  },
  {
    id: 'dt50-rebar-data-analysis-summary',
    title: '钢筋优化管理 · 数据分析汇总',
    component: () =>
      import('../design-test-views/DesignTest50RebarDataAnalysisSummaryView.vue'),
  },
  {
    id: 'dt51-rebar-data-analysis-summary',
    title: '钢筋优化管理 · 数据分析汇总 v2',
    component: () =>
      import('../design-test-views/DesignTest51RebarDataAnalysisSummaryView.vue'),
  },
  {
    id: 'dt52-mix-notice-app',
    title: '配合比通知单 · App',
    component: () =>
      import('../design-test-views/DesignTest52MixNoticeAppView.vue'),
  },
];
